import { useEffect } from 'react';
import { useScrollPercentage } from 'react-scroll-percentage/dist';
import { Tween } from 'react-gsap';
import ReactGA from 'react-ga4';
// import { ScrollTrigger as ScrollTriggerPlugin } from 'gsap/dist/ScrollTrigger';
import Header from './components/header';
import ProgressBar from './components/progress-bar';
import SectionIntro from './components/section/intro';
import SectionImage from './components/section/image';
import SectionImages from './components/section/images';
import SectionImageText from './components/section/image-text';
import SectionText from './components/section/text';
import SectionVideo from './components/section/video';
import Footer from './components/footer';
import styles from './App.module.scss';

// ScrollTriggerPlugin.normalizeScroll(true);

ReactGA.initialize('G-1NHCZXL2CB');

function App() {
  useEffect(() => {
    ReactGA.send('pageview');
  });

  const [ref, percentage] = useScrollPercentage({
    threshold: 0,
  });

  return (
    <div ref={ ref } className={ styles.App }>
      <Header />
      <ProgressBar progress={ percentage } />

      <SectionImage
        scrub={ false }
        src="images/01/cover.jpg"
        className={ styles.s01 }
      >
        <Tween duration={ 1 } from={{ opacity: 0, scale: 1.5 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/01/jackson-wang.png` } className={ styles.jacksonWang } />
        </Tween>
      </SectionImage>

      <SectionIntro />

      <SectionImageText
        className={ styles.s03 }
        imageClassName={ styles.image }
        imageSrc="images/03/cover-v2.jpg"
        imagePosition="right"
        textClassName={ styles.text }
        text={
          <>
            在一個昏暗大雨的下午，我相約與王嘉爾在 COMPLEX 洛杉磯的錄影室裡見面，工作行程排得滿滿的王嘉爾只有 40 小時留在洛杉磯，無論天氣如何，各自團隊都必須專業地完成這次任務。
            <br /><br />
            在訪問之前相信樂迷們早已目睹了王嘉爾這幾年在國際舞台上所散發著無限的能量並不斷轉化成全球性的人氣和影響力；他的名字總是出現在全球品牌和創意單位爭相邀請合作和代言的名單中，這位「國際王」並非浪得虛名。
            <br /><br />
            當然王嘉爾也是 COMPLEX 中文編輯部熱門討論的名字，我已經想不起大概在什麼時候想到邀請王嘉爾成為 COMPLEX 中文第一位封面人物：是在他超人氣單曲衝破五千萬流量的時候？還是榮登 iTunes 美國單曲總榜及流行榜榜首的時候？還是當王嘉爾與 Gucci Mane、Internet Money 這些國際知名的藝術家一起出現的時候？又或是今年成為第一位站上美國最大型音樂節 Coachella 主舞台中國 Solo 歌手的時候？ 事實上，他也是全球 Instagram 上最多追隨者的華人第一。這位年僅 28 歲，擁有兩張個人專輯的全能藝人，最近更正式展開全球巡迴演出，曼谷首站過萬的門票一掃而空，座無虛席；之後開始橫跨全球，陸續途徑倫敦、巴黎等地，並將在 2023 年繼續新一輪的 MAGIC MAN 巡演。當越來越多王嘉爾創作生涯重要時刻出現的時候，讓這個問題的答案變得越來越明顯。
          </>
        }
      >
        {/* <img src={ `${process.env.PUBLIC_URL}/images/03/complex.png` } className={ styles.complex } />
        <img src={ `${process.env.PUBLIC_URL}/images/03/an-open-dialogue-with.png` } className={ styles.anOpenDialogWith } />
        <img src={ `${process.env.PUBLIC_URL}/images/03/jackson-wang.png` } className={ styles.jacksonWang } /> */}
      </SectionImageText>

      <SectionImage
        scrub
        src="images/04/select-14.jpg"
        className={ styles.s04 }
      >
        {/* <img src={ `${process.env.PUBLIC_URL}/images/04/side.png` } className={ styles.side } /> */}
      </SectionImage>

      <SectionImageText
        className={ styles.s05 }
        imageClassName={ styles.image }
        imageSrc="images/05/colors-2.jpg"
        imagePosition="right"
        textClassName={ styles.text }
        text={
          <>
            <img src={ `${process.env.PUBLIC_URL}/images/05/title.png` } className={ styles.title } />
            <br />
            王嘉爾剛剛坐下受訪者的位置，王嘉爾開首表明他已經預備好嘗試更多的身分，問題是讀者準備好了沒有？
            <br /><br />
            「你想聽到最商業和保險的答案，還是最真實的王嘉爾？」我為讀者選擇了後者。王嘉爾沒有太多預設公式化的回答，在鏡頭前預備展現自己真實的一面，偶爾將坦率的真性情表露無遺，如果你一直有關注王嘉爾也可能發現到這點。這位粉絲們主觀心目中無所不能的偶像，此刻卻想你通過這次的封面故事了解到他最人性的一面，過程中不時襲來低落情緒和感觸，有點讓我意想不到。
            <br /><br />
            「真實」是我對於眼前這位耀眼巨星的第一印象，放下墨鏡，用上普通語、上海話、英文展開輕鬆、自然和坦承的對話，沒有多餘的寒暄，也沒有巨星的架子，感覺像是一位很久不見的舊朋友。或許放眼全球，橫觀歐美流行音樂界，破格的藝術家們都時刻保持著真實的自我，我們熱愛這些藝術家們，不單欣賞他們的才華橫溢，而且有一種年輕人擁抱的原始氣質和能夠引發世人共鳴的磁場，在他們的創作中總能感受到他們最真實和直接的想法，同時間接地把觀眾自己有口難言的心聲盡情抒發，解脫心中的悶氣，而每一位曾經登上 COMPLEX 封面的藝術家們都有著同樣的特質。
          </>
        }
      >
        <img src={ `${process.env.PUBLIC_URL}/images/05/crown.png` } className={ styles.crown } />
      </SectionImageText>

      <SectionImage
        scrub
        src="images/06/bg-full.jpg"
        className={ styles.s06 }
      >
        {/* <img src={ `${process.env.PUBLIC_URL}/images/06/side.png` } className={ styles.side } /> */}
        <Tween from={{ opacity: 0, x: '-20%' }} to={{ opacity: 1, x: '0%' }}>
          <img src={ `${process.env.PUBLIC_URL}/images/06/brush.png` } className={ styles.brush } />
        </Tween>
        <Tween from={{ opacity: 0, scale: 2 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/06/quote1.png` } className={ styles.quote } />
        </Tween>
      </SectionImage>

      <SectionImageText
        className={ styles.s07 }
        imageClassName={ styles.image }
        imageSrc="images/07/select-18.jpg"
        imagePosition="left"
        textClassName={ styles.text }
        text={
          <>
            <img src={ `${process.env.PUBLIC_URL}/images/07/title.png` } className={ styles.title } />
            <br />
            中國香港土生土長的王嘉爾成長於一個運動世家，爸爸是國家劍擊運動員、媽媽是國家體操運動員，哥哥也在澳洲從事橄欖運動。從小開始接觸各種不同運動的王嘉爾在 10 歲時愛上了劍擊，而且成績非常優異，曾為中國香港劍擊代表隊隊員並在 2011 年參加亞洲青少年劍擊錦標賽奪得亞洲第一，成為最年輕的金牌選手，在運動員跑道上有著耀眼的起點。在 2010 年，王嘉爾通過韓國娛樂公司 JYP 的選拔，不顧家人反對，憑著對於音樂的熱忱以及運動員堅強的特質，毅然獨自遠赴韓國當練習生，在韓國娛樂體系極度嚴苛的 制度下受訓，面對比起專業運動員更大的壓力，而努力過後的故事亦已經成為了歷史。
            <br /><br />
            三十未滿的王嘉爾稱得上幾乎無所不能的新生代全方位創作者，但這種成功的氛圍很容易讓人迷失。王嘉爾出道將近十年，雖然說不上很長的時間，當像他這樣急速冒起的藝人走上如此頂峰後，也會遇到新的樽頸，無論是影響力的進一步提升，還是對自我的審視和認知，例如決定 Solo 發展後的王嘉爾也曾經歷一段迷失的時候，即使到現在對自己時刻也有所懷疑。相信沒有外人會想像到這位「能量偶像」成功背後的困惑，甚至對他來說演藝事業已經開始變成一個令人窒息的閉循環。「一浪接一浪的工作，例行公事已經令我變得麻木，甚至我對自己已經沒有感覺，甚至對身邊的事情也失去了感覺。」王嘉爾坦然向我剖白，他在精神上經歷過頻臨崩潰的邊緣。
            <br /><br />
            「低潮的時期，我拒絕與任何人溝通，是任何人，甚至連 TEAM WANG 的同伴也以為我在發藝術家脾氣。」當時王嘉爾最大的迷思是：「為甚麼我不能夠做回自己，縱使得不到觀眾的認同、縱使在商業上一敗塗地，至少我能感受到真實的自己。」就如 2021 年初 TEAM WANG《ME vs ME》概念展覽中的命題：「What you become is never about anything but yourself, you choose, you plan, you do, know yourself, make your own history.」每一次的自我懷疑成為了最大的成長動力。
          </>
        }
      >
        <img src={ `${process.env.PUBLIC_URL}/images/07/heart.png` } className={ styles.heart } />
      </SectionImageText>

      <SectionImageText
        className={ styles.s08 }
        imageClassName={ styles.image }
        imageSrc="images/08/select-17.jpg"
        imagePosition="right"
        imageCredit={ "Jacket - SANKUANZ\nPants - SANKUANZ\nSunglasses - Bonnie Clyde" }
        imageCreditClassName={ styles.credit }
        textClassName={ styles.text }
        text={
          <>
            <img src={ `${process.env.PUBLIC_URL}/images/08/title.png` } className={ styles.title } />
            <br />
            王嘉爾在音樂和演藝創作上的努力，對於他的忠實樂迷來說是毋容置疑的事實，「hard-working」幾乎成為了他的人生信條，即使在我與他相處的短短時間中，「努力」成為出現率最高的詞語。但對於現在的王嘉爾來說，他對「努力」兩個字卻充滿疑惑。「在音樂上，我一直埋頭苦幹，很努力和很用心去做好每件事，最後懵然未覺發現根本沒有真正用心去感受自己所做的事情。例如我熱愛的音樂、時裝、舞蹈等領域，其實它們都是一門藝術，而藝術創作往往建基於自己最直觀的感覺，我想現在是時候騰出空間讓去感受或是接納自己內心最真實的情感。」這是王嘉爾遺憾未能早點領悟到的事情。
            <br /><br />
            「外界從不同渠道和範疇接觸到的我，其實只是一個碎片化的王嘉爾，我很感謝他們，但我更渴望外界能認識到真正的 Jackson Wang，可能並不是你們心目所期待的，但那就是我。」這一切王嘉爾對於自己的反思，成就了《MAGIC MAN》這一張專輯，不單是他商業與口碑上最成功的專輯，甚至被譽為他出道至今最成熟和出色的作品，同時也是王嘉爾對於自己最坦承的獨白。「MAGIC MAN 是一個抽象的概念，就像你經歷了人生中不同高峰與低谷，徹底尋求自我後，成就了今天更加完整的你，在這個非常 magical 的旅程中最終呈現出最真實的自己，成為了自己的 MAGIC MAN，自我終極形態的一致展現。」王嘉爾深知道只是努力是不夠的，在創作的道路有誰不努力呢？所以他一致保持著謙卑，抓住每一個可能的契機，繼續不斷地向前進擊。
          </>
        }
      >
        <img src={ `${process.env.PUBLIC_URL}/images/08/arrows.png` } className={ styles.arrows } />
      </SectionImageText>

      <SectionImage
        scrub
        src="images/09/bg.jpg"
        className={ styles.s09 }
      >
        {/* <img src={ `${process.env.PUBLIC_URL}/images/09/side.png` } className={ styles.side } /> */}
        <Tween from={{ opacity: 0, scale: 2 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/09/quote1.png` } className={ styles.quote } />
        </Tween>
      </SectionImage>

      <SectionText className={ styles.s10 }>
        <Tween from={{ opacity: 0, scale: 2 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/10/title.png` } className={ styles.title } />
        </Tween>
        <br />
        <div className={ styles.body }>
          <Tween from={{ opacity: 0, x: '-50%' }} to={{ opacity: 1, x: '0%' }}>
            <div className={ styles.parenthesis }>
              <img src={ `${process.env.PUBLIC_URL}/images/10/left.png` } className={ styles.left } />
            </div>
          </Tween>
          <Tween from={{ opacity: 0, scale: 1.25 }} to={{ opacity: 1, scale: 1 }}>
            <div className={ styles.text }>
              王嘉爾第二張錄音室專輯《MAGIC MAN》並非緊跟《MIRRORS》之後，在向瑞典電音二人組 Galantis 合作取經後，王嘉爾感受到市場和觀眾最直接的反饋，重新審視和打破自我的迷茫。當帶著《MAGIC MAN》回歸的時候，我看到的並不是一張純為粉絲或上榜製作的專輯，也不是一張自我陶醉的音樂專輯，而是一份去蕪存菁的自我獨白。這裡有返璞歸真的旋律；有極儘自我的態度；有內心二元對立的糾結；有野性和荷爾蒙的爆發；也有壓抑和憤怒的蓄力。總之，整張專輯能讓觀眾體感到王嘉爾創作過程中的一種埋藏在內心已久的矛盾和衝擊，像是迷霧中一段探尋與掙扎，就如《Come Alive》一曲中所示，當經歷過一段充滿自我掙扎的迷途後，是時候再步入一個全新階段。
              <br /><br />
              在這次與 COMPLEX 的對談中，王嘉爾也袒露他藏在內心最深處，同時也是最真實的渴望：「我想要我粉絲認識到最真實的王嘉爾，了解到你們所支持的 Jackson Wang 到底是什麼，無論如何我想讓你們認識一個不會戴上面具，永遠保持真實的王嘉爾。」因為他深知道在天花亂墜的娛樂工業中，這是唯一的出路，而《MAGIC MAN》就是王嘉爾這番說話的鐵證，也是一張完全展現真實自我的音樂作品。如果說他以前作品重點講述他的成長故事，那麼《MAGIC MAN》則是 Jackson Wang 勇敢面對自己並完全擁抱自己全部的一面鏡子。
            </div>
          </Tween>
          <Tween from={{ opacity: 0, x: '50%' }} to={{ opacity: 1, x: '0%' }}>
            <div className={ styles.parenthesis }>
              <img src={ `${process.env.PUBLIC_URL}/images/10/right.png` } className={ styles.right } />
            </div>
          </Tween>
        </div>
      </SectionText>

      <SectionImages
        className={ styles.s11 }
        leftSrc="images/11/select-23.jpg"
        leftClassName={ styles.left }
        rightSrc="images/11/select-21.jpg"
        rightClassName={ styles.right }
        rightCredit={ "Jacket - NAMESAKE\nPants - NAMESAKE\nShoes - Kidsuper" }
        rightCreditClassName={ styles.credit }
      >
        <Tween from={{ opacity: 0, x: '-20%' }} to={{ opacity: 1, x: '0%' }}>
          <img src={ `${process.env.PUBLIC_URL}/images/11/arrow.png` } className={ styles.arrow } />
        </Tween>
      </SectionImages>

      <SectionImage
        scrub
        src="images/12/bg-full.jpg"
        className={ styles.s12 }
      >
        {/* <img src={ `${process.env.PUBLIC_URL}/images/12/side.png` } className={ styles.side } /> */}
        <Tween from={{ opacity: 0, x: '20%' }} to={{ opacity: 1, x: '0%' }}>
          <img src={ `${process.env.PUBLIC_URL}/images/12/brush.png` } className={ styles.brush } />
        </Tween>
        <Tween from={{ opacity: 0, scale: 2 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/12/quote1.png` } className={ styles.quote } />
        </Tween>
      </SectionImage>

      <SectionText pin className={ styles.s13 }>
        <Tween from={{ opacity: 0, scale: 2 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/13/title.png` } className={ styles.title } />
        </Tween>
        <br />
        <Tween from={{ opacity: 0 }} to={{ opacity: 1 }}>
          <div className={ styles.body }>
            <div className={ styles.text }>
              作為國際演藝舞台最前線的創作者，王嘉爾深知道社交媒體帶來的輿論力量，在強大得可怕的互聯網時代，跌落「神壇」可能只是一眨眼的事情。當人們現在每天接收到的信息比十年前幾何倍數上升而且隨手可得的時候，人們往往更容易忽略了信息的真實性。而活在社交媒體中的粉絲和歌迷也已經習慣看到一個「完美」的偶像，他們帶著極其挑剔的目光審視著偶像的一舉一動。這也是王嘉爾一直面對的真實現狀，有時候這種目光變成了一種約束甚至遺憾，面具成為保護自己的第一道防線。
              <br /><br />
              面對娛樂事業中種種海量不實的謠言，王嘉爾有時會感到無所適從，但也坦然接受娛樂事業中的殘酷現實，沒有人會關心事實的真相，或許一個完全出於惡搞目的的剪輯影片馬上招來成千上萬人的謾罵，享受著娛樂花邊新聞帶來一絲快感，對於閒言閒語，王嘉爾只能當作一笑置之的噪音。而事實上他也歡迎聽到不一樣的聲音，無論積極的或負面的，他知道有反饋總是好的，因為王嘉爾深信：「自己該做什麼，不該做什麼，不應因為藝人的角色來作出抉擇；而是應作為一個普通人根據自己的信念和良知而為，無論你是一個藝人或普通人，請不要裝，因為總有一天會被人識破。」關於「人設」的問題，哪有完美的人？哪有無懈可擊的人性？王嘉爾更在乎的是真實；甚至人氣對他來說也只是一個泡沫，他深知道五年、十年後，可能沒有會記得王嘉爾這個人，他只在乎自己做的事情，讓作品說話。
              <br /><br />
              我們作為創意和娛樂行業內的媒體和夥伴，每天也看到這些殘酷的現實，希望能夠通過我們的視角，讓觀眾也能從更客觀地去了解和接納自己喜歡的藝術家們的不完美。
            </div>
            <img src={ `${process.env.PUBLIC_URL}/images/13/line.png` } className={ styles.line } />
          </div>
        </Tween>
      </SectionText>

      <SectionImage
        scrub
        src="images/14/photo-full.jpg"
        className={ styles.s14 }
      >
        {/* <img src={ `${process.env.PUBLIC_URL}/images/14/side.png` } className={ styles.side } /> */}
      </SectionImage>

      <SectionImageText
        className={ styles.s15 }
        imageClassName={ styles.image }
        imageSrc="images/15/jw-goat-look-1-90.jpg"
        imagePosition="left"
        textClassName={ styles.text }
        text={
          <>
            <img src={ `${process.env.PUBLIC_URL}/images/15/title.png` } className={ styles.title } />
            <br />
            2022 年王嘉爾以一個張力十足的賣力表演征服了 Coachella 主舞台，還現身北美另一大型音樂節 Lollapalooza 作為演出嘉賓，並將作為 Lollapalooza 的表演嘉賓前往印度演出；還有電競遊戲《英雄聯盟》2022 總決賽的開幕嘉賓，同場表演的嘉賓還有 Lil Nas X；他還驚喜亮相 COMPLEX 旗下美食頻道《First We Feast》等歐美流行文化節目，影響力直捲全球。對於外界常常形容「衝出國際的華人代表」這一頂高帽，王嘉爾不認為自己在打破文化邊界上所做的努力有多麼值得一提，他認為成龍、李連杰、楊紫瓊、林書豪、姚明等傳奇人物才是王嘉爾心目中真正促進東西方之間文化交流的先行者們，而自己只不過是在走這些前輩們已經開拓好的道路。「我並不是代表什麼國家，進軍了什麼地方，也不是什麼偉大的代表或領隊。我認為世界大同，不同文化已經緊密連結在一起，而我希望能在前人鋪好的路上走的更遠，挖得更深一點，尋找各自文化背後最真實可貴的東西，並非表面的刻板印象。」
          </>
        }
      >
        <img src={ `${process.env.PUBLIC_URL}/images/15/circle.png` } className={ styles.circle } />
      </SectionImageText>

      <SectionText scrub className={ styles.s16 }>
        <Tween from={{ opacity: 0, x: '-40%' }} to={{ opacity: 1, x: '0%' }}>
          <img src={ `${process.env.PUBLIC_URL}/images/16/arrow.png` } className={ styles.arrow } />
        </Tween>
        <br />
        <Tween from={{ opacity: 0, scale: 2 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/16/title.png` } className={ styles.title } />
        </Tween>
        <br />
        <Tween from={{ opacity: 0 }} to={{ opacity: 1 }}>
          <p className={ styles.text }>
            王嘉爾作為一個工作狂，他每出現一次，基本上意味著王嘉爾將有一個新的企劃即將出現。歌手、個人品牌 TEAM WANG 主理人、設計師、PANTHRPACK 成員等頭銜對於王嘉爾都只是一個好聽的名字而已，只是代表他在不同領域所做的事情，對於頭銜，他更在乎成果。「我人生唯一會令我生氣的事情就是我的工作。每次我都很重視我的工作，我不能接受微乎其微的缺陷和風險。」第一次聽到這番說法，讓我馬上聯想到王嘉爾會是一位可怕的老闆，但事實並非如此。
            <br /><br />
            王嘉爾對事業的認真和投入，幾乎感染了身邊所有的人，甚至把所有信任的朋友都變成了自己團隊裡一起打天下的夥伴。而面對競爭如此激烈的跨媒體娛樂事業，他們互相扶持，夥伴也成為了王嘉爾面對無比壓力的一個出口。因為這位舞台上極其耀眼的藝術家，台下依然會感到孤獨和困惑，而面對種種壓力與困難，王嘉爾認為最重要的是：「懂得分享很重要，身邊能有一群充滿正能量的朋友也十分重要，當你跟他們分享自己內心不悅的時候，不是去依賴他們或是在他們身上尋找答案，而是讓自己有一個感動安全的出口，將內心所有的憤怒、雜念宣洩出來。夥伴們一個關懷眼神、一個支持的動作對我來說已經非常足夠。」如 16 世紀英國詩人 John Donne 所言「沒有人是一座孤島」，無論你是天王巨星還是默默為生活打拼的普通人，我們總需要同伴扶持。
          </p>
        </Tween>
      </SectionText>

      <SectionImage
        src="images/17/select-17.jpg"
        className={ styles.s17 }
      >
        {/* <img src={ `${process.env.PUBLIC_URL}/images/17/side.png` } className={ styles.side } /> */}
      </SectionImage>

      <SectionText className={ styles.s18 }>
        <Tween from={{ opacity: 0, scale: 2 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/18/quote.png` } className={ styles.quote } />
        </Tween>
        <br />
        <Tween from={{ opacity: 0, x: '50%' }} to={{ opacity: 1, x: '0%' }}>
          <img src={ `${process.env.PUBLIC_URL}/images/18/line.png` } className={ styles.line } />
        </Tween>
      </SectionText>

      <SectionVideo src="https://www.youtube.com/embed/c08O_Ilbjaw" />

      <SectionImageText
        className={ styles.s19 }
        imageClassName={ styles.image }
        imageSrc="images/19/colors.jpg"
        imagePosition="left"
        imageCredit={ "Jacket - NAMESAKE\nJeans - kahut\nSunglasses - Bonnie Clyde\nBelt - SANKUANZ\nShoes - Kidsuper" }
        imageCreditClassName={ styles.credit }
        textClassName={ styles.text }
        text={
          <>
            <img src={ `${process.env.PUBLIC_URL}/images/19/title.png` } className={ styles.title } />
            <br />
            無論你怎樣評價這位明星，王嘉爾所付出遠超常人的辛勤努力都是真實的。當一位年輕運動員毅然走上國際演藝、音樂和時裝的大舞台，無論在哪一個地方，哪一個領域，他都像是一位帶來新衝擊的外來者，事業上每一次的轉變，每一次跳出自己的舒適區漸漸成為了王嘉爾的習慣，甚至是成長背後的動力。唯一令人遺憾的是他似乎沒有像一位「hometown hero」般受到凱旋而歸的熱烈簇擁。不過怎樣的視野將決定你將會走上什麼樣的道路，這位 MAGIC MAN 總能以外人的身份挑戰和實現更高的理想。
            <br /><br />
            王嘉爾認為在現今如此「magical」的年代，無論任何範疇或是任何的創作已經沒有清晰的界線。「無論是搖滾、Hip Hop 或是 R&B 已經沒有 100% 純粹的音樂類型，不同種族、地域，所有新、舊時代中的文化已經放進了這時代的大熔爐之中，塑造成全新的事物。」這正是王嘉爾認為當今之世最「magical」的地方。但要在這花花世界找到自己的定位，唯一的指南針就是自己的真實性，然後再一步步向自己的夢想進發。「夢想是一個很個人的事情，當你非常沈迷一樣東西，甚至當你認定這就是你的夢想的時候，最重要的是相信自己的直覺，勇敢去冒險。我自己也錯過了很多機會，因為我想太多了。」
          </>
        }
      >
        <img src={ `${process.env.PUBLIC_URL}/images/19/top-right-times.png` } className={ styles.topRightTimes } />
        <img src={ `${process.env.PUBLIC_URL}/images/19/bottom-left-times.png` } className={ styles.bottomLeftTimes } />
      </SectionImageText>

      <SectionImage
        scrub
        src="images/20/bg.jpg"
        className={ styles.s20 }
      >
        {/* <img src={ `${process.env.PUBLIC_URL}/images/20/side.png` } className={ styles.side } /> */}
        <Tween from={{ opacity: 0, scale: 1.5, x: '20%' }} to={{ opacity: 1, scale: 1, x: '0%' }}>
          <img src={ `${process.env.PUBLIC_URL}/images/20/quote.png` } className={ styles.quote } />
        </Tween>
      </SectionImage>

      <SectionText className={ styles.s21 }>
        <Tween from={{ opacity: 0, scale: 2 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/21/title.png` } className={ styles.title } />
        </Tween>
        <br />
        <Tween from={{ opacity: 0 }} to={{ opacity: 1 }}>
          <p className={ styles.text }>
            無形的文化壁壘似乎禁錮了無數音樂人的創造力以及向世人分享的強烈慾望。王嘉爾能以華人面孔殺入海外主流音樂市場並非易事，在如今全球年輕創意文化大融合的年代，誰能在專注自我表達的同時勇於突破文化壁壘，誰也將有機會獲得前所未有的國際關注和影響力，王嘉爾身體力行向我們證實了這一點，也是不少亞洲勇於冒險的藝術家們的縮影，他們就像開疆拓土的勇士，憑著專業、自信、熱情以及敬畏之心，勇闖世界音樂、藝術、時尚、影視等創作領域，全球更大的市場等著他們去征服和改寫。王嘉爾也證明了放下了以往舊身份後，向世界展示自己內心最純粹的想法，能夠突破語言，文化和價值觀等界限，引起不同文化背景的觀眾心中的共鳴，也許是華人衝破文化界限進軍國際主流的重要一步。
            <br /><br />
            無論你是否相信魔法的存在，但魔術師台後的努力總是來得如此真實並值得鼓舞。
          </p>
        </Tween>
        <Tween from={{ opacity: 0, x: '-20%' }} to={{ opacity: 1, x: '0%' }}>
          <img src={ `${process.env.PUBLIC_URL}/images/21/heart.png` } className={ styles.heart } />
        </Tween>
      </SectionText>

      <SectionVideo src="https://www.youtube.com/embed/6cIKMVx5IkY" />

      <Footer
        credits={[
          { title: 'Executive Producer', name: 'Bonnie Chan Woo & Steven Wang' },
          { title: 'Interviewer', name: 'Aki' },
          { title: 'Editor', name: 'Oscar Law' },
          { title: 'Design Direction', name: 'Nicole Law & Jking Xu' },
          { title: 'Writer', name: 'Nick Fu' },
          { title: 'Web Design', name: 'Matt Yiu' },
          { title: 'Photographer', name: 'Matt Cowen' },
          { title: 'Lighting Technician', name: 'Alec Salerno' },
          { title: 'Digital Technician', name: 'James Armas' },
          { title: 'Photo Assistant', name: 'James Phan' },
          { title: 'Stylist', name: 'QZ' },
          { title: 'Styling Assistant', name: 'Dre Romeo' },
          { title: 'Wardrobe Assistant', name: 'Maria Li' },
          { title: 'Clothing Credit', name: 'LOOK1: Jacket by SANKUANZ; Pants by SANKUANZ; Sunglasses by Bonnie Clyde;\nLOOK2: Jacket by NAMESAKE; Pants by NAMESAKE; Shoes by Kidsuper;\nLOOK3 : Jacket by NAMESAKE; Jeans by kahut; Sunglasses by Bonnie  Clyde; Belt by SANKUANZ; Shoes by Kidsuper; Earbuds by BEATS.' },
        ]}
      />
    </div>
  );
}

export default App;
